export const pointGuardStats = [
    {
        actual_name: "PlayerPoints",
        display_name: "PTS",
    },
    {
        actual_name: "PlayerRebounds",
        display_name: "REB",
    },
    {
        actual_name: "PlayerAssists",
        display_name: "AST",
    },
    {
        actual_name: "PlayerSteals",
        display_name: "STL",
    },
    {
        actual_name: "PlayerBlockedShots",
        display_name: "BLK",
    },
    {
        actual_name: "PlayerTurnovers",
        display_name: "TO",
    },
    {
        actual_name: "Dream11ProjectedFantasyPoints",
        display_name: "FP",
    },
];

export const shootingGuardStats = [
    {
        actual_name: "PlayerPoints",
        display_name: "PTS",
    },
    {
        actual_name: "PlayerRebounds",
        display_name: "REB",
    },
    {
        actual_name: "PlayerAssists",
        display_name: "AST",
    },
    {
        actual_name: "PlayerSteals",
        display_name: "STL",
    },
    {
        actual_name: "PlayerBlockedShots",
        display_name: "BLK",
    },
    {
        actual_name: "PlayerTurnovers",
        display_name: "TO",
    },
    {
        actual_name: "Dream11ProjectedFantasyPoints",
        display_name: "FP",
    },
];
export const smallForwardStats = [
    {
        actual_name: "PlayerPoints",
        display_name: "PTS",
    },
    {
        actual_name: "PlayerRebounds",
        display_name: "REB",
    },
    {
        actual_name: "PlayerAssists",
        display_name: "AST",
    },
    {
        actual_name: "PlayerSteals",
        display_name: "STL",
    },
    {
        actual_name: "PlayerBlockedShots",
        display_name: "BLK",
    },
    {
        actual_name: "PlayerTurnovers",
        display_name: "TO",
    },
    {
        actual_name: "Dream11ProjectedFantasyPoints",
        display_name: "FP",
    },
];

export const powerForwardStats = [
    {
        actual_name: "PlayerPoints",
        display_name: "PTS",
    },
    {
        actual_name: "PlayerRebounds",
        display_name: "REB",
    },
    {
        actual_name: "PlayerAssists",
        display_name: "AST",
    },
    {
        actual_name: "PlayerSteals",
        display_name: "STL",
    },
    {
        actual_name: "PlayerBlockedShots",
        display_name: "BLK",
    },
    {
        actual_name: "PlayerTurnovers",
        display_name: "TO",
    },
    {
        actual_name: "Dream11ProjectedFantasyPoints",
        display_name: "FP",
    },
];

export const centerStats = [
    {
        actual_name: "PlayerPoints",
        display_name: "PTS",
    },
    {
        actual_name: "PlayerRebounds",
        display_name: "REB",
    },
    {
        actual_name: "PlayerAssists",
        display_name: "AST",
    },
    {
        actual_name: "PlayerSteals",
        display_name: "STL",
    },
    {
        actual_name: "PlayerBlockedShots",
        display_name: "BLK",
    },
    {
        actual_name: "PlayerTurnovers",
        display_name: "TO",
    },
    {
        actual_name: "Dream11ProjectedFantasyPoints",
        display_name: "FP",
    },
];